import { Symbol } from './context'
const contextSymbolIterator = Symbol ? Symbol.iterator : undefined
export default contextSymbolIterator
